import { appURLs } from "@/app/constants.mjs";
import * as GraphQLTemplates from "@/feature-wallet/graphql-templates.mjs";
import type { PaymentProviderType } from "@/feature-wallet/models/payment-method-provider.mjs";
import { postGQL, queryGQL } from "@/util/gql-formatters.mjs";

export function getUserTransactions() {
  return queryGQL(appURLs.PAYMENTS, GraphQLTemplates.transactions, {});
}

export function getUserPaymentMethods() {
  return queryGQL(appURLs.PAYMENTS, GraphQLTemplates.paymentMethods, {});
}

export function getUserSubscriptions() {
  return queryGQL(appURLs.PAYMENTS, GraphQLTemplates.subscriptions, {});
}

export function getPaymentPlans() {
  return queryGQL(appURLs.PAYMENTS, GraphQLTemplates.paymentPlans, {});
}

export function createBraintreeClientToken() {
  return postGQL(
    appURLs.PAYMENTS,
    GraphQLTemplates.createBraintreeClientToken,
    {},
  );
}

export function createPaymentMethod({
  isDefault,
  paymentMethodId,
  providerType,
  testClock,
}: {
  isDefault?: boolean;
  paymentMethodId: string;
  providerType: PaymentProviderType;
  testClock?: string;
}) {
  return postGQL(appURLs.PAYMENTS, GraphQLTemplates.postPaymentMethod, {
    isDefault,
    paymentMethodId,
    providerType,
    testClock,
  });
}

export function checkCoupon({ couponCode, providerType }) {
  return queryGQL(appURLs.PAYMENTS, GraphQLTemplates.checkCoupon, {
    couponCode,
    providerType,
  });
}

export function postRemovePayMethod({ paymentMethodId, providerType }) {
  return postGQL(appURLs.PAYMENTS, GraphQLTemplates.removePaymentMethod, {
    paymentMethodId,
    providerType,
  });
}

export function postUpdateDefaultPayMethod({ paymentMethodId, providerType }) {
  return postGQL(appURLs.PAYMENTS, GraphQLTemplates.updateDefaultPayment, {
    paymentMethodId,
    providerType,
  });
}

export function postUpdateSubscription({ paymentMethodId, plan }) {
  return postGQL(appURLs.PAYMENTS, GraphQLTemplates.updateSubscription, {
    paymentMethodId,
    plan,
  });
}

export function postCancelSubscription({ cancellationReason, plan }) {
  return postGQL(appURLs.PAYMENTS, GraphQLTemplates.cancelSubscription, {
    cancellationReason,
    plan,
  });
}
